import Image from "next/image";

function PlayStoreWhiteLogo({ redirectUrl }) {
  return (
    <a href={redirectUrl} target="_blank" rel="noreferrer">
      <button>
        <Image
          src="/assets/logo/play-store-white.svg"
          width={144}
          height={44}
          alt="play-store"
        />
      </button>
    </a>
  );
}

export default PlayStoreWhiteLogo;
